/**
 * Which boats a new event builds by default. B15 is the shared training hull:
 * no team owns it, so the form lists it but builds it only when the admin
 * ticks it (ADR-092). Pure, so the rule is unit-testable (the frontend suite
 * has no DOM harness).
 */

/** The NVP key of the shared training hull (`Boat.boat_code`). */
export const SHARED_HULL_CODE = "B15";

export function defaultSelectedBoatIds(
  boats: ReadonlyArray<{ id: string; boat_code: string }>,
): Set<string> {
  return new Set(
    boats
      .filter((boat) => boat.boat_code !== SHARED_HULL_CODE)
      .map((boat) => boat.id),
  );
}
